import React, { useContext, useMemo } from 'react';
import { lastDayOfMonth, matrixReducer } from 'simple-utils/dist/date-utils';
import { DailyReport } from '../../models/FullReportEntry';
import { AccountContext } from '../AccountContext';
import { SummaryClickChart } from './ClickChart';
import { SummaryCostChart } from './CostChart';
import { SummaryLeadChart } from './LeadChart';

function dailyReportSummary(report: DailyReport[][]){
    return matrixReducer(report, i => i.date, f => ({...f}), (c, i) => {
        return {...c, leads: c.leads + i.leads, cost: c.cost + i.cost}
    });
}

export function SummaryCharts(){
    const {filtered} = useContext(AccountContext);
    const {report, past} = useMemo(function(){
        if(!filtered || !filtered.length) return {report: null, past: null}

        let report = filtered.map(a => a.dailyReports)
        report = report.filter(a => a != null && a.length) 
        //let past = filtered.map(a => a.past?.dailyReports).filter(a => a != null)

        if(!report.length) return {report: null, past: null}

        let date = lastDayOfMonth(report[0][0].date);
        let past = [[{date, leads: 0, cost: 0, clicks: 0}]];

        return {
            report: dailyReportSummary(report),
            past: dailyReportSummary(past)
        }

    }, [filtered]);

    if(!filtered || !filtered.length)
        return null;

    if(!report)
        return null;

    return <div className='row mt-4'>
            <div className='col-lg mt-3'>
                <h4>Leads</h4>
                <SummaryLeadChart report={report} past={past} />
            </div>
            <div className='col-lg mt-3'>
                <h4>Cliques</h4>
                <SummaryClickChart report={report} past={past} />
            </div>
            <div className='col-lg mt-3'>
                <h4>Investimento</h4>
                <SummaryCostChart report={report} past={past} />
            </div>
        </div>
}